module.exports = __webpack_public_path__ + "static/media/t04ru.685a9b41.pdf";